import { useQuery } from '@tanstack/react-query'
import { getMeService } from '@/services/auth'

export const ME_QUERY_KEY = ['me']

export const useMe = () =>
  useQuery({
    queryKey: ME_QUERY_KEY,
    queryFn: getMeService,
  })
